import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { DictionariesDTO } from '@core/dto/dictionaries.dto';
import { Dictionaries } from '@core/models/dictionaries.model';
import { BootstrapLoaderService } from '@core/loader/bootstrap-loader.service';
import { AppStoreService } from '@core/state';
import { deserialize } from '@junte/serialize-ts';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class DictionariesGuard {
  constructor(
    private api: ApiService,
    private appStoreService: AppStoreService,
    private bootstrapLoader: BootstrapLoaderService,
  ) {}

  public canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.bootstrapLoader.track('dictionaries', this.api.get<DictionariesDTO>('common/dictionaries')).pipe(
      tap((dictionaries) => {
        const dict = deserialize(dictionaries, Dictionaries);
        this.appStoreService.updateAvailableAssetClasses(dict.assetClasses);
        this.appStoreService.updateAvailableCountries(dict.countries);
        this.appStoreService.updateAvailableEsgComplianceOptions(dict.esgCompliance);
        this.appStoreService.updateAvailableIndustries(dict.industries);
        this.appStoreService.updateAvailableInvestorClasses(dict.investorClasses);
        this.appStoreService.updateAvailableClientClasses(dict.clientClass);
        this.appStoreService.updateAvailableRatings(dict.ratings);
        this.appStoreService.updateAvailableLanguages(dict.languages);
        this.appStoreService.updateAvailableSalutations(dict.salutations);
        this.appStoreService.updateAvailableTitles(dict.titles);
        this.appStoreService.updateAvailableOccupations(dict.occupation);
        this.appStoreService.updateAvailableBusinessTypes(dict.businessType);
        this.appStoreService.updateAvailableMainSourceOfFunds(dict.mainSourceOfFunds);
      }),
      map(() => true),
    );
  }
}
